<!-- <mat-card>
    <mat-card-header class="justify-content-between align-items-center mb-3">
      <mat-card-title class="fs-5 mb-0"> Latest messages </mat-card-title>
      <button
        mat-button
        color="primary"
  
      >
        See more
      </button>
    </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table
        [columnHeaders]="tableDisplayColumns"
        [dataSource]="messageLIst"
        [showImageColumn]="true"

        class="latest-user-list"

        [imageTemplate]="image"
       
        [itemsPerPage]="5"
      >
      </sm-data-table>
    </div>
  </mat-card>

  <ng-template #image let-objValue>
    <img
      [src]="
        objValue['imageUrl'] !== null && objValue['imageUrl'] !== 'null'
          ? objValue['imageUrl']
          : './assets/images/user-avatar.svg'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>
   -->
<div
  style="
    padding: 16px;
    margin-bottom: 35px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  "
>
  <mat-card-header class="justify-content-between align-items-center mb-3">
    <mat-card-title class="fs-5 mb-0">
      {{ "dashboard.latest_noti" | translate }}
    </mat-card-title>
    <button mat-button color="primary" (click)="seeallnoti()" *ngIf="messageLIst.length > 0 && messageLIst.length > 10">
      {{ "dashboard.see_more" | translate }}
    </button>
  </mat-card-header>
  <mat-dialog-content>
    <div class="row" *ngIf="messageLIst.length > 0">
      <div class="col-sm-12" *ngFor="let item of messageLIst">
        <div class="fl_orders">
          <div class="top_section_order">
            <div class="row">
              <div class="col-sm-1">
                <div class="ads_sec">
                  <div
                    class="hm_icon_progr"
                    *ngIf="
                      item.senderImgThumbUrl && item.senderImgThumbUrl != 'null'
                    "
                  >
                    <img [src]="item.senderImgThumbUrl" />
                  </div>
                  <div
                    class="hm_icon_progr"
                    *ngIf="
                      !item.senderImgThumbUrl ||
                      item.senderImgThumbUrl == 'null'
                    "
                  >
                    <img src="../../../../assets/images/photo.png" />
                  </div>
                </div>
              </div>
              <div class="col-sm-11" style="padding-left: 22px">
                <div class="order_dec">
                  <div class="tick_opklads">
                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                    <!-- <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon -->
                    {{ item.creationDate | date }}
                  </div>
                  <h3
                    style="
                      -webkit-box-orient: vertical;
                      display: -webkit-box;
                      -webkit-line-clamp: 1;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: normal;
                      margin-bottom: 8px;
                    "
                  >
                    {{ item.title }}
                  </h3>
                  <p>
                    {{ item.description }}
                    <!-- </p>
                                  <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                  </p>
                                  <p>Approx Time: {{item.approxTime}} minutes
                                  </p> -->
                    <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                    <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="messageLIst.length == 0">
      <div class="col-sm-12" >
        <div style="padding: 20px 18px 20px 18px;
        background: var(--color-primary-contrast);
        border-radius: var(--dra-radius-x-small);
        cursor: pointer;
        transition: 0.3s;">
          <div class="top_section_order">
            <div class="row">
              <div style="text-align: center;min-height: 200px;
              padding-top: 40px;">
              <div>
                <div>
                  <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 3L21 21M9.37747 3.56325C10.1871 3.19604 11.0827 3 12 3C13.5913 3 15.1174 3.59 16.2426 4.6402C17.3679 5.69041 18 7.11479 18 8.6C18 10.3566 18.2892 11.7759 18.712 12.9122M17 17H15M6.45339 6.46451C6.15686 7.13542 6 7.86016 6 8.6C6 11.2862 5.3238 13.1835 4.52745 14.4866C3.75616 15.7486 3.37051 16.3797 3.38485 16.5436C3.40095 16.7277 3.43729 16.7925 3.58603 16.9023C3.71841 17 4.34762 17 5.60605 17H9M9 17V18C9 19.6569 10.3431 21 12 21C13.6569 21 15 19.6569 15 18V17M9 17H15" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                 </div>
              </div>
                <p style="color: var(--color-primary-light);margin-top: 20px;">No notifications to show</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
